// This file should only contain action type constants.

export const SET_QUICK_SPECS = 'SET_QUICK_SPECS';
export const SET_VEHICLE_TYPE = 'SET_VEHICLE_TYPE';
